import { Icon } from '../ui/Icon'

/**
 * A group's face — the owner's picture when they set one (owner, 2026-10-18: Group Owner 也可以上傳一個照片用
 * 來標示 Group 的顯示的 icon), else the groups glyph on its tile. One component for every place a group is drawn.
 */
export function GroupFace({ icon, big = false }: { icon?: string | null | undefined; big?: boolean }) {
  return icon ? (
    <img className={`grp-face grp-face-img${big ? ' big' : ''}`} src={icon} alt="" />
  ) : (
    <span className={`grp-face grp-face-icon${big ? ' big' : ''}`} aria-hidden="true">
      <Icon name="groups" size={big ? 22 : 16} />
    </span>
  )
}
